export default "__VITE_ASSET__913469ea__"